import { WORKFLOW_DEFINITION } from '@dealstack/shared/lib/temporal/workflowDefinitions';

/** Deriving the id from the programme is what makes a second start collide in Temporal. */
export function createBulkPostDatingWorkflowId(programmeId: string): string {
	return `${WORKFLOW_DEFINITION.bulkPostDating.workflows.bulkPostDatingWorkflow.workflowIdPrefix}-${programmeId}`;
}
